// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1nWU7","footer":"Form_footer__2iNrV"};